import { BsArrowRight } from '@react-icons/all-files/bs/BsArrowRight';
import { Link } from 'gatsby';
import type { FC } from 'react';

const ContactUsWidget: FC = () => {
  return (
    <div className="bg-action-btn py-14">
      <div className="container text-gray-50 px-6 m-auto">
        <div className="flex md:flex-row flex-col justify-between items-center gap-10">
          <div className="max-w-xl">
            <h6 className="text-3xl font-semibold mb-3">
              Get in touch with us about anything.
            </h6>
            <p className="text-sm text-gray-300 font-light">
              Connect with our team to explore the alloy solutions and machinery
              expertise you need.
            </p>
          </div>
          <Link
            className="bg-gray-50 text-gray-950 px-6 py-3 font-medium 
            flex space-x-2 items-center transition-smooth hover:-translate-y-1.5
             shadow-md hover:shadow-2xl whitespace-nowrap md:w-auto w-full justify-center"
            to="/contact-us"
          >
            <span>Contact Us</span>
            <BsArrowRight className="text-base" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContactUsWidget;
